/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import FieldItem from '../fieldItem'
import { Text, Box, useDisclosure } from '@chakra-ui/react'
import {
  accountCode,
  loadFinalValue,
  prepareFinalFieldValueForEdit,
} from '../../../utils/form.util'
import { formatDDMMYYYYHHMM } from '../../../utils/date.utils'
import { useValidateGroupAccountName } from '../../../hooks/form.hooks'
import { useSmartFormContext } from '../../../context/smart-form.context'
import { smartFormConst } from '../../../utils/action.constant'
import { useAuthContext } from '../../../context/auth.context'
import AlertBox from '../../AlertBox'

const FormFieldList = ({
  fieldList,
  isSmartForm,
  onShowAction,
  showFormAction,
  accountCheckOn,
  formData,
  formAddFly,
  isOnFly,
  setEnableSubmit,
  setCheckValidate = () => {},
  setSmartFieldListSmart = () => {},
  scrollToBottom = () => {},
  onShowDescription = () => {},
  ...rest
}) => {
  const [currentField, setcurrentField] = useState(null)
  const [accountError, setaccountError] = useState(null)
  const [isSkip, setSkip] = useState(true)
  const [smartFieldList, setSmartFieldList] = useState([])
  const [count, setCount] = useState(0)
  const { mutate: mutateAccountNameValidate } = useValidateGroupAccountName()
  const { isOpen: isAlertOpen, onOpen, onClose: alertClose } = useDisclosure()
  const [alertMessage, setAlertMessage] = useState('')

  const {
    state: { fields },
    dispatch,
  } = useSmartFormContext()

  const {
    state: {
      authData: { organization_flag_enable_grid },
    },
  } = useAuthContext()

  const lastFieldRef = useRef()

  const scrollToLastField = () => {
    setTimeout(() => {
      lastFieldRef?.current?.scrollIntoView({ behavior: 'smooth' })
    }, 0)
  }

  useEffect(() => {
    if (fieldList && !!fieldList.length) {
      let cField = fieldList[0]
      let skipList = rest?.skipFieldList
      if (!!cField && !!rest.isBulkEdit) {
        setSmartFieldList(fieldList)
        setcurrentField(cField)
      } else if (!!cField && !!rest.refillView) {
        let { form_id } = cField
        let refillFields =
          !!rest.refillData && !!rest.refillData[form_id]
            ? Object.keys(rest.refillData[form_id])
            : []
        let fieldRefill = fieldList.filter(f =>
          refillFields.includes(`${f.field_id}`)
        )
        setSmartFieldList(fieldRefill)
        setcurrentField(fieldRefill[fieldRefill.length - 1])
        onShowAction(true)
      } else if (!!skipList && skipList?.length) {
        renderNextField(skipList, cField, [cField])
      } else {
        setSmartFieldList([cField])
        setcurrentField(cField)
      }
    }
  }, [fieldList, rest?.skipFieldList, rest?.refillData])

  useEffect(() => {
    setSmartFieldListSmart(smartFieldList)
  }, [smartFieldList])

  const renderNextField = (list, cField, finalFields = []) => {
    let isSkipField = list.includes(cField.field_id)
    if (isSkipField) {
      let skipField =
        !!fields[cField.form_id] && !!fields[cField.form_id][cField.field_id]
          ? fields[cField.form_id][cField.field_id]
          : null
      if (!!skipField && skipField.final.field_data_type_id === 33) {
        let f = fieldList.filter(f => f.field_id === cField.field_id)
        let options = !!f && f[0]?.options
        if (!!options) {
          let s_opt = options.filter(
            c => c.data_type_combo_id === skipField.final.data_type_combo_id
          )
          if (!!s_opt) {
            if (s_opt[0].comboNextFieldId === 0) {
              const ci1 = fieldList.findIndex(
                f => f.field_id === cField.field_id
              )
              const cFieldN1 = fieldList[ci1 + 1]
              if (!!cFieldN1) {
                let isSkipField = list.includes(cFieldN1.field_id)
                if (isSkipField) {
                  finalFields = [...finalFields, cFieldN1]
                  renderNextField(list, cFieldN1, finalFields)
                } else {
                  setSmartFieldList(finalFields)
                  setcurrentField(cField)
                  if (
                    cField.next_field_id === -1 ||
                    (!isSmartForm && finalFields.length === fieldList.length)
                  ) {
                    onShowAction(true)
                  }
                }
              } else {
                setSmartFieldList(finalFields)
                setcurrentField(cField)
                if (
                  cField.next_field_id === -1 ||
                  (!isSmartForm && finalFields.length === fieldList.length)
                ) {
                  onShowAction(true)
                }
              }
            } else if (s_opt[0].comboNextFieldId === -1) {
              setSmartFieldList(finalFields)
              setcurrentField(cField)
              onShowAction(true)
            } else {
              let nxtf = fieldList.filter(
                f => f.field_id === s_opt[0].comboNextFieldId
              )
              if (!!nxtf && !!nxtf[0]) {
                let isSkipField = list.includes(nxtf[0].field_id)
                if (isSkipField) {
                  finalFields = [...finalFields, ...nxtf]
                  renderNextField(list, nxtf[0], finalFields)
                } else {
                  setSmartFieldList(finalFields)
                  setcurrentField(cField)
                  if (
                    cField.next_field_id === -1 ||
                    (!isSmartForm && finalFields.length === fieldList.length)
                  ) {
                    onShowAction(true)
                  }
                }
              } else {
                setSmartFieldList(finalFields)
                setcurrentField(cField)
                if (
                  cField.next_field_id === -1 ||
                  (!isSmartForm && finalFields.length === fieldList.length)
                ) {
                  onShowAction(true)
                }
              }
            }
          }
        }
      } else {
        let cNxtField = !!isSmartForm
          ? fieldList.find(f => f.field_id === cField.next_field_id)
          : false
        if (!!isSmartForm && !!cNxtField) {
          let isSkipField = list.includes(cNxtField.field_id)
          if (isSkipField) {
            finalFields = [...finalFields, cNxtField]
            renderNextField(list, cNxtField, finalFields)
          } else {
            if (finalFields.length < list.length && !!cNxtField) {
              finalFields = [...finalFields, cNxtField]
              renderNextField(list, cNxtField, finalFields)
            } else {
              setSmartFieldList(finalFields)
              setcurrentField(cField)
              if (
                cField.next_field_id === -1 ||
                (!isSmartForm && finalFields.length === fieldList.length)
              ) {
                onShowAction(true)
              }
            }
          }
        } else {
          const ci = fieldList.findIndex(f => f.field_id === cField.field_id)
          const cFieldN = fieldList[ci + 1]
          if (!!cFieldN) {
            let isSkipField = list.includes(cFieldN.field_id)
            if (isSkipField) {
              finalFields = [...finalFields, cFieldN]
              renderNextField(list, cFieldN, finalFields)
            } else {
              if ([21, 17].includes(cFieldN.data_type_id)) {
                finalFields = [...finalFields, cFieldN]
                renderNextField(list, cFieldN, finalFields)
              } else {
                setSmartFieldList(finalFields)
                setcurrentField(cField)
                if (
                  cField.next_field_id === -1 ||
                  (!isSmartForm && finalFields.length === fieldList.length)
                ) {
                  onShowAction(true)
                }
              }
            }
          } else {
            setSmartFieldList(finalFields)
            setcurrentField(cField)
            if (
              cField.next_field_id === -1 ||
              (!isSmartForm && finalFields.length === fieldList.length)
            ) {
              onShowAction(true)
            }
          }
        }
      }
    } else {
      if (finalFields.length < list.length) {
        let cNxtField = !!isSmartForm
          ? fieldList.find(f => f.field_id === cField.next_field_id)
          : false
        if (!!isSmartForm && !!cNxtField) {
          finalFields = [...finalFields, cNxtField]
          renderNextField(list, cNxtField, finalFields)
        } else {
          const ci2 = fieldList.findIndex(f => f.field_id === cField.field_id)
          const cFieldN2 = fieldList[ci2 + 1]
          if (!!cFieldN2) {
            finalFields = [...finalFields, cFieldN2]
            renderNextField(list, cFieldN2, finalFields)
          } else {
            setSmartFieldList(finalFields)
            setcurrentField(cField)
            if (
              cField.next_field_id === -1 ||
              (!isSmartForm && finalFields.length === fieldList.length)
            ) {
              onShowAction(true)
            }
          }
        }
      } else {
        setSmartFieldList(finalFields)
        setcurrentField(cField)
        if (
          cField.next_field_id === -1 ||
          (!isSmartForm && finalFields.length === fieldList.length)
        ) {
          onShowAction(true)
        }
      }
    }
    scrollToLastField()
  }

  // useEffect(() => {
  //   if (fieldList && !!fieldList.length) {
  //     let cField = fieldList[0];
  //     if (!!cField) {
  //       setSmartFieldList([cField]);
  //       setcurrentField(cField);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (!!currentField && Object.keys(currentField).length && isSkip) {
      handleLabelField(currentField)
    }
  }, [currentField])

  const handleLabelField = cField => {
    let refillItem =
      !!rest.refillData &&
      Object.keys(rest.refillData).length &&
      rest.refillData[cField.form_id] &&
      rest.refillData[cField.form_id][cField.field_id]
    let fieldItem =
      !!rest.autoPopuateList &&
      rest.autoPopuateList.find(value => !!value[cField.field_id])
    if (!!fieldItem) {
      let fieldValue = {
        ...cField,
        field_data_type_id: cField.data_type_id,
        field_value: fieldItem[cField.field_id],
      }
      dispatch({
        type: smartFormConst.SET_FIELD_VALUE,
        fieldId: cField.field_id,
        formId: cField.form_id,
        value: loadFinalValue(
          cField,
          prepareFinalFieldValueForEdit(fieldValue, cField)
        ),
      })
    } else if (!!refillItem) {
      dispatch({
        type: smartFormConst.SET_FIELD_VALUE,
        fieldId: cField.field_id,
        formId: cField.form_id,
        value: refillItem,
      })
    }
    if (
      !!cField.data_type_id &&
      !!isSmartForm &&
      organization_flag_enable_grid === 1
    ) {
			let select_options =
				cField.data_type_id === 33
					? [
							...new Set(
								cField.options.map(c => c.comboNextFieldId).filter(Boolean)
							),
					  ]
					: [0]
			let prefill =
				!!cField.field_value_prefill_enabled &&
				cField.field_value_prefill_enabled === 1
			if (
				(smartFieldList.length < fieldList.length &&
					select_options?.length === 1) ||
				(!prefill && cField.data_type_id === 33)
			) {
				if (cField.data_type_id === 33) {
					if (select_options.includes(0)) {
						onContinue(cField.next_field_id)
					}
				} else {
					onContinue(cField.next_field_id)
				}
			} else if (smartFieldList.length === fieldList.length) {
				onShowAction(true)
			}
    } else if (
      cField.data_type_id &&
      !isSmartForm &&
      organization_flag_enable_grid === 1
    ) {
      onContinue(cField.next_field_id)
    }
    if (cField?.field_inline_data?.field_skip_condition) {
      let { data_type_combo_id, field_id } =
        cField.field_inline_data.field_skip_condition
      let skipComboId =
        !!fields[cField.form_id] && !!fields[cField.form_id][field_id]
          ? fields[cField.form_id][field_id]?.final?.data_type_combo_id
          : null
      if (data_type_combo_id === skipComboId) {
        setCount(count => count + 1)
        onContinue(cField.next_field_id)
      }
    }
    if (!!cField && [21, 17].includes(cField.field_data_type_id)) {
      onContinue(cField.next_field_id)
      dispatch({
        type: smartFormConst.SET_FIELD_VALUE,
        fieldId: cField.field_id,
        formId: cField.form_id,
        value: {
          final: {
            form_id: cField.form_id,
            field_id: cField.field_id,
            field_reference_id: cField.field_reference_id,
            field_name: cField.field_name,
            field_data_type_id: 0,
            field_data_type_category_id: 0,
            data_type_combo_id: '0',
            message_unique_id: 0,
            field_value: '',
          },
          field_value: '',
          is_skip: true,
        },
      })
    }
  }

  const toNextField = nextFieldId => {
    /**
     * NOTE: make sure smart form end fields should have nextFieldId as -1 or no field with 0
     */
    if (String(Number(nextFieldId)) === 'NaN') {
      onShowAction(true)
      setcurrentField({})
      return
    }
    if (
      nextFieldId === -1 ||
      (!isSmartForm && smartFieldList.length === fieldList.length)
    ) {
      onShowAction(true)
      setcurrentField({})
      return
    }
    let cField = !!isSmartForm
      ? fieldList.find(f => f.field_id === nextFieldId)
      : false
    if (!!isSmartForm && !!cField) {
      setcurrentField(cField)
      setSmartFieldList([...smartFieldList, cField])
    } else if (!!isSmartForm && !cField) {
      setAlertMessage(
        'Seems there is an issue with form. Please reach out to your administrator to resolve this.'
      )
      onOpen()
      return false
    } else {
      const ci = fieldList.findIndex(f => f.field_id === currentField.field_id)
      const cField = fieldList[ci + 1]
      if (!!cField) {
        setcurrentField(cField)
        setSmartFieldList([...smartFieldList, cField])
      } else {
        onShowAction(true)
        setcurrentField({})
        return
      }
    }
    if (organization_flag_enable_grid !== 1) {
      scrollToLastField()
    }
    setSkip(true)
  }

  const onContinue = (nextFieldId, isset = false) => {
    let isSkipField =
      !!rest?.skipFieldList && rest?.skipFieldList.includes(nextFieldId)
    if (!isSkipField || !!isset) toNextField(nextFieldId)
    return
    // if (
    //   smartFieldList.length === 1 &&
    //   accountCheckOn === accountCode.ACCOUNT_NAME
    // ) {
    //   // TODO: handle account code validation
    //   let firstField = smartFieldList[0];
    //   let title;
    //   if ([19, 20].includes(firstField.field_id)) {
    //     title = fields[firstField.field_id];
    //   } else {
    //     title = `${formData.form_name}-${formatDDMMYYYYHHMM()}`;
    //   }
    // mutateAccountNameValidate(
    //   {
    //     activity_title: title,
    //     activity_type_id: formData.form_workflow_activity_type_id,
    //   },
    //   {
    //     onSuccess: async data => {
    //       if (data.isError) {
    //         setaccountError(data.message);
    //       } else {
    //         console.log('data');
    //         setaccountError(null);
    //         toNextField(nextFieldId);
    //         toNextField(nextFieldId);
    //         // TODO: Use the generated_group_account_code while save
    //       }
    //     },
    //     onError: async err => {
    //       console.log('error for logging of check name');
    //     },
    //   }
    // );
    // } else {
    //   toNextField(nextFieldId);
    // }
  }

  const onPrevious = index => {
    // TODO show the modal to user wether he want to override the values.
    const nonSkipFields = smartFieldList.slice(index, smartFieldList.length)
    const skippedFieldList = smartFieldList.slice(0, index + 1)
    setcurrentField(skippedFieldList[index])
    setSmartFieldList(skippedFieldList)
    setSkip(false)
    let submittedValues = Object.keys(fields[smartFieldList[0].form_id])
    let finalRevertedValues = {}
    Object.keys(fields).forEach(k => {
      if (Number(k) !== Number(smartFieldList[0].form_id)) {
        finalRevertedValues[k] = fields[k]
      }
    })
    finalRevertedValues[smartFieldList[0].form_id] = {}
    submittedValues.forEach(fId => {
      let isExist = skippedFieldList.find(i => i.field_id === Number(fId))
      let isEventData = nonSkipFields.find(
        i => i.field_id === Number(fId) && i.data_type_id === 77
      )
      if (isExist && !isEventData) {
        finalRevertedValues[smartFieldList[0].form_id][fId] =
          fields[smartFieldList[0].form_id][fId]
      } else if (isEventData) {
        finalRevertedValues[smartFieldList[0].form_id][fId] = {
          ...fields[smartFieldList[0].form_id][fId],
          field_value: {
            ...fields[smartFieldList[0].form_id][fId].field_value,
            isFromEdit: true,
          },
        }
      }
    })
    dispatch({
      type: smartFormConst.SET_FIELD_VALUES,
      formId: smartFieldList[0].form_id,
      fields: finalRevertedValues,
    })
    if (!!showFormAction) {
      onShowAction(false)
    }
  }
  return (
    <>
      {smartFieldList && !!smartFieldList.length ? (
        (smartFieldList || []).filter(Boolean).map((field, index) => {
          return (
            <FieldItem
              activity={rest.activity}
              current={currentField}
              field={field}
              fieldList={fieldList}
              fieldIndex={index}
              key={field.field_id}
              onContinue={onContinue}
              onPrevious={onPrevious}
              showFieldAction={showFormAction}
              accountError={accountError}
              onFormAddFly={formAddFly}
              workforceForms={rest.workforceForms}
              isOnFly={isOnFly}
              isBulkEdit={rest.isBulkEdit}
              onSaveDraft={rest.onSaveDraft}
              activity_type_flag_enable_draft={
                formData.activity_type_flag_enable_draft
              }
              skipFieldList={rest?.skipFieldList}
              refillView={rest.refillView}
              setEnableSubmit={setEnableSubmit}
              isSmartForm={isSmartForm}
              setCheckValidate={setCheckValidate}
              scrollToBottom={scrollToBottom}
              onShowDescription={onShowDescription}
            />
          )
        })
      ) : (
        <Text>Loading...</Text>
      )}
      <Box ref={lastFieldRef} />
      <AlertBox
        isOpen={isAlertOpen}
        onClose={alertClose}
        Message={alertMessage}
      />
    </>
  )
}

export default FormFieldList
